var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxllLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.003 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1151.286 -6462.036)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1151.286 6462.036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.474 39.528 31.504 2.819A5.537 5.537 0 0 0 27.282.047a4.712 4.712 0 0 0-1.326 0 5.519 5.519 0 0 0-4.222 2.772L.748 39.528a5.7 5.7 0 0 0 2.04 7.717 5.553 5.553 0 0 0 7.6-2.027l.022-.039 16.2-28.358 16.2 28.358a5.55 5.55 0 0 0 7.58 2.092l.044-.025a5.673 5.673 0 0 0 2.04-7.717Z",
    fill: "#3183e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1277.994 6462.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.878 37.738H9.96V4.998a4.98 4.98 0 1 0-9.96 0V42.91a5.17 5.17 0 0 0 1.134 3.213 3.591 3.591 0 0 0 .332.354c.062.07.13.135.2.2a4.95 4.95 0 0 0 3.176 1.147h20.029a5.041 5.041 0 0 0 0-10.081Z",
    fill: "#3183e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1321.415 6462.071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.85 37.841H9.964V5.102a4.98200371 4.98200371 0 1 0-9.962-.2V43.013a5.048 5.048 0 0 0 1.466 3.568 2.146 2.146 0 0 0 .2.2 4.9 4.9 0 0 0 3.174 1.148h20.01a5.041 5.041 0 0 0 0-10.082Z",
    fill: "#3183e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1214.749 6462.098)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.824 47.878a4.808 4.808 0 0 1-3.4-1.4 4.859 4.859 0 0 1-.032-6.85L39.078 1.434a4.834 4.834 0 0 1 6.856 6.815L8.247 46.443a4.8 4.8 0 0 1-3.423 1.435Z",
    fill: "#3183e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.004 .038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.992 18.934A4.815 4.815 0 0 1 10.56 17.5L1.392 8.213a4.825 4.825 0 0 1 6.866-6.78l9.168 9.284a4.827 4.827 0 0 1-3.434 8.217Z",
    fill: "#3183e7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.491 28.701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.014 18.956a4.807 4.807 0 0 1-3.432-1.434l-9.19-9.309a4.824 4.824 0 0 1 6.866-6.778l9.19 9.307a4.824 4.824 0 0 1-3.434 8.214Z",
    fill: "#3183e7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxllLogo);
export default __webpack_public_path__ + "static/media/axll-logo.b69419d05f1011e27ec871f21d62b982.svg";
export { ForwardRef as ReactComponent };